export type VuexExerciseActionNameList =
  | "ATTEMPT_EXERCISE_CLOSE"
  | "CLEAR_EXERCISE"
  | "EXERCISE_DETAILS_REQUEST"
  | "FETCH_EXERCISE"
  | "HINTS_DISPLAY_HIDE"
  | "HINTS_DISPLAY_SHOW"
  | "HINTS_DISPLAY_TOGGLE"
  | "INCREMENT_PAGE"
  | "LOG_ANSWER"
  | "LOG_END"
  | "LOG_EXERCISE_ANSWER"
  | "LOG_EXERCISE_END"
  | "LOG_START"
  | "LOG_EXERCISE_START"
  | "NAVIGATE_TO_NEXT"
  | "NAVIGATION_ATTEMPT"
  | "NAVIGATION_CANCELLATION"
  | "NAVIGATION_CONFIRMATION"
  | "NAVIGATION_MODAL_CLOSE"
  | "NAVIGATION_MODAL_OPEN"
  | "RESET_EXERCISE"
  | "RESTART_EXERCISE"
  | "SETTINGS_POPUP_CLOSE"
  | "SETTINGS_POPUP_OPEN"
  | "SETTINGS_POPUP_TOGGLE";
export type VuexExerciseActionNames = {
  [T in VuexExerciseActionNameList]: string;
};

export type VuexExerciseMutationNameList =
  | "ANSWER"
  | "EXERCISE_DETAILS"
  | "EXERCISE_LOADING"
  | "EXERCISE"
  | "EXERCISE_ACCURACY"
  | "EXERCISE_LOG_ID"
  | "EXERCISE_RESULTS"
  | "HINTS_SETTING"
  | "IN_PROGRESS"
  | "LIMITED_MODE_UPDATED"
  | "LOADING"
  | "NAVIGATION_MODAL_STATUS"
  | "NAVIGATION_NEXT_FUNCTION"
  | "NEXT_PAGE"
  | "PROCESSING"
  | "SETTINGS_POPUP_STATUS"
  | "TOTAL_STATE_RESET";
export type VuexExerciseMutationNames = {
  [T in VuexExerciseMutationNameList]: string;
};

export type VuexExerciseGetterNameList =
  | "ANSWERS"
  | "ASSIGNMENTS_SUBMITTED"
  | "BODY"
  | "CURRENT_PAGE"
  | "DETAILS"
  | "EXERCISE_ACCURACY"
  | "EXERCISE_PAGES"
  | "EXERCISE_RESULTS"
  | "EXERCISE_TYPE"
  | "FINAL_QUESTION"
  | "FOOTER"
  | "LOADING"
  | "LOG_ID"
  | "LOG_ANSWER_PARAMS"
  | "LOG_END_PARAMS"
  | "LOG_START_PARAMS"
  | "PAGE_TYPE"
  | "PROBLEM_UUID"
  | "PROCESSING"
  | "REVIEW_PAGE";
export type VuexExerciseGetterNames = {
  [T in VuexExerciseGetterNameList]: string;
};

export const VUEX_EXERCISE_NAMESPACE = "exercise";

export const VUEX_EXERCISE_ACTION_NAMES: VuexExerciseActionNames = {
  ATTEMPT_EXERCISE_CLOSE: "attempt_exercise_close",
  CLEAR_EXERCISE: "clear_exercise",
  EXERCISE_DETAILS_REQUEST: "exercise_details_request",
  FETCH_EXERCISE: "fetch_exercise",
  HINTS_DISPLAY_HIDE: "hints_display_hide",
  HINTS_DISPLAY_SHOW: "hints_display_show",
  HINTS_DISPLAY_TOGGLE: "hints_display_toggle",
  INCREMENT_PAGE: "increment_page",
  LOG_ANSWER: "log_answer",
  LOG_END: "log_end",
  LOG_EXERCISE_ANSWER: "log_exercise_answer",
  LOG_EXERCISE_END: "log_exercise_end",
  LOG_EXERCISE_START: "log_exercise_start",
  LOG_START: "log_start",
  NAVIGATE_TO_NEXT: "navigate_to_next",
  NAVIGATION_CANCELLATION: "navigation_cancellation",
  NAVIGATION_CONFIRMATION: "navigation_confirmation",
  NAVIGATION_ATTEMPT: "navigation_attempt",
  NAVIGATION_MODAL_CLOSE: "navigation_modal_close",
  NAVIGATION_MODAL_OPEN: "navigation_modal_open",
  RESET_EXERCISE: "reset_exercise",
  RESTART_EXERCISE: "restart_exercise",
  SETTINGS_POPUP_CLOSE: "settings_popup_close",
  SETTINGS_POPUP_OPEN: "settings_popup_open",
  SETTINGS_POPUP_TOGGLE: "settings_popup_toggle"
};

export const VUEX_EXERCISE_MUTATION_NAMES: VuexExerciseMutationNames = {
  ANSWER: "answer",
  EXERCISE_DETAILS: "exercise_details",
  EXERCISE_LOADING: "exercise_loading",
  EXERCISE: "exercise",
  EXERCISE_ACCURACY: "exercise_accuracy",
  EXERCISE_LOG_ID: "exercise_log_id",
  EXERCISE_RESULTS: "exercise_results",
  HINTS_SETTING: "hints_setting",
  IN_PROGRESS: "in_progress",
  LIMITED_MODE_UPDATED: "limited_mode_updated",
  LOADING: "loading",
  NAVIGATION_MODAL_STATUS: "navigation_modal_status",
  NAVIGATION_NEXT_FUNCTION: "navigation_next_function",
  NEXT_PAGE: "next_page",
  PROCESSING: "processing",
  SETTINGS_POPUP_STATUS: "settings_popup_status",
  TOTAL_STATE_RESET: "total_state_reset"
};

export const VUEX_EXERCISE_GETTER_NAMES: VuexExerciseGetterNames = {
  ANSWERS: "answers",
  ASSIGNMENTS_SUBMITTED: "assignments_submitted",
  BODY: "body",
  CURRENT_PAGE: "current_page",
  DETAILS: "details",
  EXERCISE_ACCURACY: "exercise_accuracy",
  EXERCISE_PAGES: "exercise_pages",
  EXERCISE_RESULTS: "exercise_results",
  EXERCISE_TYPE: "exercise_type",
  FINAL_QUESTION: "final_question",
  FOOTER: "footer",
  LOADING: "loading",
  LOG_ID: "log_id",
  LOG_ANSWER_PARAMS: "log_params",
  LOG_END_PARAMS: "log_end_params",
  LOG_START_PARAMS: "log_start_params",
  PAGE_TYPE: "page_type",
  PROBLEM_UUID: "problem_uuid",
  PROCESSING: "processing",
  REVIEW_PAGE: "review_page"
};
